import { join } from 'teacher-ui-client/utils/uri'
import GravityV3Adapter from 'teacher-ui-client/adapters/gravity/v3-adapter'

export default class SchoolTrialCountAdapter extends GravityV3Adapter {
  /**
   * NOTE:
   * by convention store.findRecord('school-trial-count', id) is passed a
   * composite id arg of the shape schoolId_subscriptionType e.g.
   * await store.findRecord('school-trial-count', '1_READING')
   * this arg isn't used by urlForFindRecord to build the request url
   * however the record returned from the server (and thus the ember
   * data store) will have an id that is equal to this value.
   */
  urlForFindRecord(_id: string, _modelName: string, { adapterOptions }: any): string {
    return join(
      this.host,
      this.namespace,
      'schools',
      adapterOptions.schoolId,
      'school-trial-counts',
      adapterOptions.subscriptionType,
    ).toString()
  }
}
